import '@mantine/carousel/styles.css';

import { Head, Link, router } from '@inertiajs/react';
import { Carousel } from '@mantine/carousel';
import {
  Accordion,
  AccordionControl,
  AccordionItem,
  AccordionPanel,
  Badge,
  Box,
  Button,
  Card,
  Container,
  Divider,
  Grid,
  GridCol,
  Group,
  Image,
  LoadingOverlay,
  Paper,
  rem,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  TextInput,
  ThemeIcon,
  useMantineTheme,
} from '@mantine/core';
import { useDisclosure, useMediaQuery, useScrollIntoView } from '@mantine/hooks';
import {
  IconArrowRight,
  IconBriefcase,
  IconBriefcaseFilled,
  IconBuildingCommunity,
  IconChartLine,
  IconHomeFilled,
  IconKeyFilled,
  IconMail,
  IconMapPin,
  IconPhone,
  IconReceiptDollarFilled,
  IconSearch,
  IconShieldCheckFilled,
  IconUsersGroup,
} from '@tabler/icons-react';

import { ButtonNavy } from '@/components/ButtonNavy.jsx';
import { FormProvider } from '@/components/form-context.js';
import { HeroTitle } from '@/components/HeroTitle.jsx';
import { HomeFaq } from '@/components/HomeFaq.jsx';
import useInertiaForm from '@/components/useInertiaForm.jsx';
import Newsletter from '@/pages/site/home/Newsletter.jsx';
import { createSiteLayout } from '@/pages/site/layouts/SiteLayout.jsx';

import BgImage from './bg.png';
import Chart from './Chart.png';
import IsoHouse from './IsoHouse.png';
import MulkSahibiBg from './MulkSahibiBg.png';
import Nasil1 from './nasil1.jpg';
import Nasil2 from './nasil2.webp';
import Sss from './Sss.png';

export default function SiteHome({ errors }) {
  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
  const isSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  // Disable Forms during load
  const [visible, handlers] = useDisclosure(false);

  router.on('start', () => {
    handlers.open();
  });

  router.on('finish', () => {
    handlers.close();
  });

  const form = useInertiaForm(
    {
      initialValues: {
        name: '',
        email: '',
        phone: '',
        msg: '',
      },
      validate: {
        name: value => (value ? null : 'Ad Soyad yazınız'),
        email: value => (value ? null : 'E-posta adresiniz yazınız'),
        phone: value => (value ? null : 'Telefon numaranızı yazınız'),
        msg: value => (value ? null : 'Mesajınızı yazınız'),
      },
      validateInputOnBlur: false,
    },
    errors,
    '/contact',
    'Mesajınız gönderildi!',
    false,
  );

  // Scroll into view

  const { scrollIntoView, targetRef } = useScrollIntoView({
    offset: 60,
  });

  // --- VERİ SETLERİ ---

  const steps = [
    { id: 1, title: 'İncele & Seç', desc: 'Bütçene, konumuna ve getiri hedeflerine göre projeni seç.' },
    { id: 2, title: 'Payını Satın Al', desc: 'Koşulları incele, seçtiğin payın ödemesini yap ve tapunu devral.' },
    { id: 3, title: 'Kira Gelirini Takip Et', desc: 'Payına düşen kira getirini sistemden takip et.' },
    {
      id: 4,
      title: 'Çıkış Fırsatlarını Değerlendir',
      desc: 'İster ikincil piyasada kendin sat, ister 5 yıl sonra mülk satışı gerçekleştiğinde kârını al.',
    },
  ];

  const featuresList = [
    {
      title: 'Tapuya Güven',
      desc: 'Paylı gayrimenkul yatırımında en önemli konu güven. Gerekli tüm süreçleri işletiyor ve tapuyu devrediyoruz.',
      icon: IconHomeFilled,
    },
    {
      title: 'Mülkü Biz Yönetelim',
      desc: 'Hisseli satılan gayrimenkullerin yönetimini biz yapıyoruz. Böylece sizi tüm dertlerden kurtarıyoruz.',
      icon: IconReceiptDollarFilled,
    },
    {
      title: 'Siz Kazanın',
      desc: 'Aylık kira getirisi alın. İlan vererek payınızı satın. Mülk satışını bekleyin ve kâr edin.',
      icon: IconChartLine,
    },
    {
      title: 'Portföyünü Çeşitlendir',
      desc: 'Farklı stratejilerle portföyünü çeşitlendir, her zaman kazan.',
      icon: IconBriefcaseFilled,
    },
  ];

  const blogPosts = [
    {
      id: 1,
      title: 'Kaçınılması Gereken En Önemli 10 Ev Satın Alma Hatası',
      date: '28',
      month: 'Pzt',
      image: 'https://placehold.co/400x250',
    },
    {
      id: 2,
      title: 'Evinizi Hızlı Satış İçin Nasıl Hazırlarsınız?',
      date: '28',
      month: 'Pzt',
      image: 'https://placehold.co/400x250',
    },
    {
      id: 3,
      title: 'İlk Kez Ev Satacaklar İçin 5 İpucu / Öneriler',
      date: '28',
      month: 'Pzt',
      image: 'https://placehold.co/400x250',
    },
  ];

  return (
    <>
      <Head>
        <title>Hisseli Gayrimenkul Yatırımı</title>
      </Head>

      {/* ================= HERO SECTION ================= */}
      <Box
        pb={100}
        style={{
          backgroundImage: `linear-gradient(to bottom, rgba(224, 222, 247, 1) 0%, rgba(224, 222, 247, 0) 100%)`,
        }}
      >
        <Container size="xl">
          <Grid align="center" gutter={50}>
            <GridCol span={{ base: 12, md: 6 }} order={{ base: 2, md: 1 }}>
              <Box maw={550} m={isMd ? 'auto' : '0'} pt={isMd ? 0 : 50}>
                <HeroTitle>Gayrimenkul hisselerini satın alın, satın ve sahip olun.</HeroTitle>
                <Text fw={500} fz={rem(20)} mt={20} lts={-0.5} c="dimmed">
                  Gerçek tapuyla desteklenen hisseli gayrimenkul yatırımı ile düzenli kira geliri elde et, servetini adım adım
                  büyüt.
                </Text>
                <ButtonNavy
                  fw={600}
                  fz={'sm'}
                  mt={'xl'}
                  size="lg"
                  radius="md"
                  rightSection={<IconArrowRight size={'1.2rem'} />}
                  onClick={() =>
                    scrollIntoView({
                      alignment: 'center',
                    })
                  }
                >
                  Yatırım Yap
                </ButtonNavy>

                {!isMd ? (
                  <Group mb={'xl'} mt={'xl'} justify={isSm ? 'center' : 'space-between'}>
                    <Stack gap={'sm'} w={isSm ? '100%' : null} align={isSm ? 'center' : 'flex-start'}>
                      <ThemeIcon
                        radius="100%"
                        w={70}
                        h={70}
                        color="purpy.1"
                        style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
                      >
                        <IconUsersGroup style={{ width: '70%', height: '70%' }} />
                        <ThemeIcon radius="10" w={30} h={30} pos={'absolute'} right={-3} bottom={-3} color="navy.8">
                          <IconKeyFilled style={{ width: '70%', height: '70%' }} />
                        </ThemeIcon>
                      </ThemeIcon>
                      <Text fw={600} fz={rem(24)} c={'navy.8'}>
                        1000+ Yatırımcı
                      </Text>
                      <Text fz={rem(16)}>hizmetimize güveniyor</Text>
                    </Stack>
                    <Stack gap={'sm'} align={isSm ? 'center' : 'flex-start'}>
                      <ThemeIcon
                        radius="100%"
                        w={70}
                        h={70}
                        color="purpy.1"
                        style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
                      >
                        <IconBuildingCommunity style={{ width: '70%', height: '70%' }} />
                        <ThemeIcon radius="10" w={30} h={30} pos={'absolute'} right={-3} bottom={-3} color="navy.8">
                          <IconSearch style={{ width: '70%', height: '70%' }} />
                        </ThemeIcon>
                      </ThemeIcon>
                      <Text fw={600} fz={rem(24)} c={'navy.8'}>
                        10+ Mülk
                      </Text>
                      <Text fz={rem(16)}>her bütçeye uygun paylar</Text>
                    </Stack>
                  </Group>
                ) : (
                  <Stack mb={'xl'} mt={'xl'}>
                    <Group wrap={'nowrap'}>
                      <ThemeIcon
                        radius="100%"
                        w={50}
                        h={50}
                        color="purpy.1"
                        style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
                      >
                        <IconUsersGroup style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Stack gap={0} align={'flex-start'}>
                        <Text fw={600} fz={rem(18)} c={'navy.8'}>
                          1000+ Yatırımcı
                        </Text>
                        <Text fz={rem(12)}>hizmetimize güveniyor</Text>
                      </Stack>
                    </Group>
                    <Group wrap={'nowrap'}>
                      <ThemeIcon
                        radius="100%"
                        w={50}
                        h={50}
                        color="purpy.1"
                        style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
                      >
                        <IconBuildingCommunity style={{ width: '70%', height: '70%' }} />
                      </ThemeIcon>
                      <Stack gap={0} align={'flex-start'}>
                        <Text fw={600} fz={rem(18)} c={'navy.8'}>
                          10+ Mülk
                        </Text>
                        <Text fz={rem(12)}>her bütçeye uygun paylar</Text>
                      </Stack>
                    </Group>
                  </Stack>
                )}
              </Box>
            </GridCol>
            <GridCol span={{ base: 12, md: 6 }} order={{ base: 1, md: 2 }}>
              <Group align={'center'} justify="center">
                <Image maw={636} src={BgImage} w="100%" />
              </Group>
            </GridCol>
          </Grid>
        </Container>
      </Box>

      {/* ================= FEATURES CARDS ================= */}
      <Container size="xl" mt={isMd ? -80 : -40} pb={isMd ? 40 : 80}>
        {isMd ? (
          <Carousel height={250} slideSize="90%" align="start" slideGap="md" controlsOffset="xs" loop withControls={false}>
            <Carousel.Slide>
              <FeatureCard icon={IconHomeFilled} title="Gayrimenkul Hissesi" desc="Hisseli Tapuyla gayrimenkullere ortak ol." />
            </Carousel.Slide>
            <Carousel.Slide>
              <FeatureCard icon={IconReceiptDollarFilled} title="Kira Getirisi" desc="Payın kadar kira getirisi elde et." />
            </Carousel.Slide>
            <Carousel.Slide>
              <FeatureCard icon={IconUsersGroup} title="Yatırım Güvencesi" desc="Resmi tapuyla yatırımların güvende olsun." />
            </Carousel.Slide>
          </Carousel>
        ) : (
          <SimpleGrid cols={{ base: 1, md: 3 }} spacing="xl">
            <FeatureCard icon={IconHomeFilled} title="Gayrimenkul Hissesi" desc="Hisseli Tapuyla gayrimenkullere ortak ol." />
            <FeatureCard icon={IconReceiptDollarFilled} title="Kira Getirisi" desc="Payın kadar kira getirisi elde et." />
            <FeatureCard icon={IconUsersGroup} title="Yatırım Güvencesi" desc="Resmi tapuyla yatırımların güvende olsun." />
          </SimpleGrid>
        )}
      </Container>

      {/* ================= HOW IT WORKS ================= */}
      <Box bg="#F8F8FF" py={60}>
        <Container size="xl">
          <Grid gutter={60} align="center">
            <GridCol span={{ base: 12, md: 6 }}>
              <Text fw={800} fz={rem(32)} c="black" mb="xl">
                Hisseli Tapu Nasıl Çalışır?
              </Text>
              <Stack gap="xl">
                {steps.map(step => (
                  <Group key={step.id} align="flex-start" wrap="nowrap">
                    <ThemeIcon size={42} radius="50%" color="navy.8" fz={20} fw={700} style={{ flexShrink: 0 }}>
                      {step.id}
                    </ThemeIcon>
                    <Box>
                      <Text fw={700} fz={rem(20)} c="black" mb={4}>
                        {step.title}
                      </Text>
                      <Text c="dimmed" fz={rem(15)} lh={1.5}>
                        {step.desc}
                      </Text>
                    </Box>
                  </Group>
                ))}
              </Stack>
            </GridCol>
            <GridCol span={{ base: 12, md: 6 }}>
              <Grid gutter="md">
                <GridCol span={6}>
                  <Image src={Nasil1} radius="lg" h={400} fit="cover" style={{ boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }} />
                </GridCol>
                <GridCol span={6} pt={60}>
                  <Image src={Nasil2} radius="lg" h={400} fit="cover" style={{ boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }} />
                </GridCol>
              </Grid>
            </GridCol>
          </Grid>
        </Container>
      </Box>

      {/* ================= FEATURED PROPERTIES ================= */}
      {/*<Box py={80}>*/}
      {/*  <Container size="xl">*/}
      {/*    <Group justify="space-between" mb="xl">*/}
      {/*      <Text fw={700} fz={rem(32)} c="black">*/}
      {/*        Öne Çıkan Gayrimenkuller*/}
      {/*      </Text>*/}
      {/*      <Anchor href="#" fw={600} c="navy">*/}
      {/*        Tümünü Gör*/}
      {/*      </Anchor>*/}
      {/*    </Group>*/}
      {/*    <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="xl">*/}
      {/*      <PropertyCard />*/}
      {/*      <PropertyCard />*/}
      {/*      <PropertyCard />*/}
      {/*    </SimpleGrid>*/}
      {/*  </Container>*/}
      {/*</Box>*/}

      {/* ================= BLUE BANNER CTA ================= */}
      <Container size="xl" py={60}>
        <Paper radius={30} bg="navy.8" p={60} py={100} style={{ position: 'relative', overflow: 'hidden' }}>
          <Grid align="center">
            <GridCol span={{ base: 12, md: 6 }} style={{ zIndex: 2 }}>
              <Text c="white" fw={800} fz={rem(40)} lh={1.1} mb="md">
                Birlikte Mülk Sahibi Olun
              </Text>
              <Text c="white" fz={rem(18)} maw={450} mb="xl" style={{ opacity: 0.9 }}>
                Ailen ve arkadaşlarınla ortak yatırım yap, mülk yönetimini bize bırak.
              </Text>
              <Button
                variant="white"
                c="navy.8"
                size="md"
                radius="md"
                rightSection={<IconArrowRight size="1.1rem" />}
                onClick={() =>
                  scrollIntoView({
                    alignment: 'center',
                  })
                }
              >
                Şimdi Başla
              </Button>
            </GridCol>
          </Grid>
          <Image
            src={MulkSahibiBg}
            fit="contain"
            visibleFrom={'sm'}
            style={{ position: 'absolute', right: 0, bottom: 0, height: 300, width: 'auto' }}
          />
        </Paper>
      </Container>

      {/* ================= NEW WAY (YENİ YOL) ================= */}
      <Container size="xl" py={60}>
        <Grid gutter={80} align="top">
          <GridCol span={{ base: 12, md: 5 }} pos={'relative'}>
            <Text fw={700} fz={rem(32)} lh={1.2} c="black" mb="lg">
              Gayrimenkul Yatırımcısının <br /> Yeni Yolu
            </Text>
            <ButtonNavy size="md" radius="md" rightSection={<IconArrowRight size="1rem" />} mb={50}>
              Detay
            </ButtonNavy>
            <Image src={IsoHouse} fit="contain" pos={'absolute'} style={{ bottom: 0, right: 0 }} w={'60%'} visibleFrom={'md'} />
          </GridCol>
          <GridCol span={{ base: 12, md: 7 }}>
            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing={50} verticalSpacing={50}>
              {featuresList.map((item, idx) => (
                <Box key={idx}>
                  <ThemeIcon
                    radius="100%"
                    w={70}
                    h={70}
                    color="purpy.1"
                    style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
                  >
                    <item.icon style={{ width: '60%', height: '60%' }} />
                    <ThemeIcon radius="10" w={30} h={30} pos={'absolute'} right={-3} bottom={-3} color="navy.8">
                      <IconShieldCheckFilled style={{ width: '70%', height: '70%' }} />
                    </ThemeIcon>
                  </ThemeIcon>
                  <Text fw={700} fz={rem(20)} c="black" mt={'sm'} mb="xs">
                    {item.title}
                  </Text>
                  <Text c="dimmed" fz={rem(15)} lh={1.5}>
                    {item.desc}
                  </Text>
                </Box>
              ))}
            </SimpleGrid>
          </GridCol>
        </Grid>
      </Container>

      {/* ================= BLOGLAR VE YAZILAR ================= */}
      {/*<Box py={80} bg="gray.0">*/}
      {/*  <Container size="xl">*/}
      {/*    <Group justify="space-between" mb="xl">*/}
      {/*      <Text fw={700} fz={rem(32)} c="navy.8">*/}
      {/*        Bloglar ve Yazılar*/}
      {/*      </Text>*/}
      {/*      <Anchor href="#" fw={600} c="blue">*/}
      {/*        Tümünü Gör*/}
      {/*      </Anchor>*/}
      {/*    </Group>*/}

      {/*    <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">*/}
      {/*      {blogPosts.map(post => (*/}
      {/*        <Paper key={post.id} radius="lg" bg="purpy.0" p="md" style={{ transition: 'all 0.3s hover' }}>*/}
      {/*          <Box pos="relative" mb="md">*/}
      {/*            <Image src={post.image} radius="md" h={200} fit="cover" />*/}
      {/*            <Paper*/}
      {/*              pos="absolute"*/}
      {/*              top={10}*/}
      {/*              left={10}*/}
      {/*              radius="md"*/}
      {/*              bg="white"*/}
      {/*              p={5}*/}
      {/*              w={50}*/}
      {/*              h={50}*/}
      {/*              style={{*/}
      {/*                display: 'flex',*/}
      {/*                flexDirection: 'column',*/}
      {/*                alignItems: 'center',*/}
      {/*                justifyContent: 'center',*/}
      {/*                lineHeight: 1,*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              <Text fw={800} fz="lg" c="navy.8">*/}
      {/*                {post.date}*/}
      {/*              </Text>*/}
      {/*              <Text fw={500} fz="xs" c="dimmed">*/}
      {/*                {post.month}*/}
      {/*              </Text>*/}
      {/*            </Paper>*/}
      {/*          </Box>*/}
      {/*          <Text fw={700} fz="lg" c="navy.8" mb="xs" lineClamp={2} h={55}>*/}
      {/*            {post.title}*/}
      {/*          </Text>*/}
      {/*          <Text fz="sm" c="dimmed" lineClamp={2} mb="md">*/}
      {/*            Etiam eget elementum elit. Aenean dignissim dapibus vestibulum.*/}
      {/*          </Text>*/}
      {/*          <Group justify="flex-end">*/}
      {/*            <ThemeIcon radius="xl" size={40} color="navy.8">*/}
      {/*              <IconArrowRight size={20} />*/}
      {/*            </ThemeIcon>*/}
      {/*          </Group>*/}
      {/*        </Paper>*/}
      {/*      ))}*/}
      {/*    </SimpleGrid>*/}
      {/*  </Container>*/}
      {/*</Box>*/}

      {/* ================= SIK SORULAN SORULAR ================= */}
      <Container size="xl" py={60}>
        <Text fw={700} fz={rem(32)} c="black" mb="xl">
          Sık Sorulan Sorular
        </Text>
        <Grid gutter={50}>
          <GridCol span={{ base: 12, md: 7 }}>
            <HomeFaq />
            <Link href={route('site.faq')}>
              <Button fullWidth variant="light" color={'blue'} c={'black'}>
                Tümünü Göster
              </Button>
            </Link>
          </GridCol>
          <GridCol span={{ base: 12, md: 5 }}>
            <Image src={Sss} radius="lg" h="400px" fit="cover" visibleFrom={'md'} />
          </GridCol>
        </Grid>
      </Container>

      {/* ================= CHART ================= */}
      <Container size="xl">
        <Text fw={700} fz={rem(32)} c="black" mb="xl">
          Gayrimenkul Uzun Vadede Hep Kazandırır
        </Text>

        <Image src={Chart} radius="md" />
      </Container>

      {/* ================= İLETİŞİM FORMU ================= */}
      <Container size="xl" py={60} ref={targetRef}>
        <Grid gutter={0} style={{ overflow: 'hidden' }}>
          {/* Sol: Form */}
          <GridCol span={{ base: 12, md: 7 }} p={50} bg="white" pos="relative">
            <Text fw={700} fz={rem(32)} c="black" mb="sm">
              Size En Uygun Gayrimenkul Çözümünü Sunmak İçin Buradayız.
            </Text>
            <Text fz={rem(18)} mb="xl">
              Gayrimenkul yatırımınızı kolaylaştırıyor, en doğru seçimi yapmanız için rehberlik ediyoruz.
            </Text>

            <FormProvider form={form}>
              <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
              <form onSubmit={e => e.preventDefault()}>
                <Grid>
                  <GridCol span={12}>
                    <TextInput label="Ad Soyad" placeholder="Ad Soyad" {...form.getInputProps('name')} />
                  </GridCol>
                  <GridCol span={6}>
                    <TextInput label="E-posta Adresiniz" placeholder="E-posta Adresiniz" {...form.getInputProps('email')} />
                  </GridCol>
                  <GridCol span={6}>
                    <TextInput label="Telefon Numaranız" placeholder="Telefon Numaranız" {...form.getInputProps('phone')} />
                  </GridCol>
                  <GridCol span={12}>
                    <Textarea label="Mesajınız" placeholder="Mesajınız" minRows={4} {...form.getInputProps('msg')} />
                  </GridCol>
                  <GridCol span={12}>
                    <ButtonNavy size="md" radius="md" rightSection={<IconArrowRight size={16} />} onClick={form.handleSubmit}>
                      Gönder
                    </ButtonNavy>
                  </GridCol>
                </Grid>
              </form>
            </FormProvider>
          </GridCol>

          {/* Sağ: İletişim Bilgileri */}
          <GridCol
            span={{ base: 12, md: 5 }}
            bg="navy.8"
            p={50}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
            }}
          >
            <Box style={{ zIndex: 2 }}>
              <Text c="white" fw={700} fz={rem(28)} mb="xl">
                İletişim Bilgileri
              </Text>
              <Stack gap="lg">
                <Group wrap="nowrap">
                  <ThemeIcon radius="xl" size="lg" color="white" c="navy.8">
                    <IconPhone size={20} />
                  </ThemeIcon>
                  <Text c="white">0216 388 66 06</Text>
                </Group>
                <Group wrap="nowrap">
                  <ThemeIcon radius="xl" size="lg" color="white" c="navy.8">
                    <IconMail size={20} />
                  </ThemeIcon>
                  <Text c="white">info@hisselitapu.com</Text>
                </Group>
                <Group wrap="nowrap" align="flex-start">
                  <ThemeIcon radius="xl" size="lg" color="white" c="navy.8">
                    <IconMapPin size={20} />
                  </ThemeIcon>
                  <Text c="white" lh={1.4}>
                    Yahya Kemal Mah. Şair Sk.
                    <br />
                    No:1 Kağıthane / İstanbul
                  </Text>
                </Group>
              </Stack>
            </Box>
            {/* Süsleme Daireleri */}
            <Box
              pos="absolute"
              bottom={-50}
              right={-50}
              w={200}
              h={200}
              bg="navy.6"
              style={{ borderRadius: '50%', opacity: 0.5 }}
            />
          </GridCol>
        </Grid>
      </Container>

      {/* ================= BÜLTEN ABONELİĞİ ================= */}
      <Box pos={'relative'}>
        <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
        <Newsletter />
      </Box>
    </>
  );
}

// --- YARDIMCI BİLEŞENLER ---

function FeatureCard({ icon: Icon, title, desc }) {
  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);

  return (
    <Paper shadow="sm" radius="lg" p="xl" withBorder style={{ borderColor: '#F1F3F5' }} mih={isMd ? 220 : 200}>
      <Stack align="center" ta="center" gap="md">
        <ThemeIcon
          radius="100%"
          w={70}
          h={70}
          color="purpy.1"
          style={{ borderWidth: 4, borderColor: 'white', boxShadow: '0px 0px 1px 1px #E0DEF7' }}
        >
          <Icon style={{ width: '60%', height: '60%' }} />
          <ThemeIcon radius="10" w={30} h={30} pos={'absolute'} right={-3} bottom={-3} color="navy.8">
            <IconShieldCheckFilled style={{ width: '70%', height: '70%' }} />
          </ThemeIcon>
        </ThemeIcon>
        <Box>
          <Text fw={700} fz={rem(18)} c="black" mb={5}>
            {title}
          </Text>
          <Text c="dimmed" fz={rem(14)} lh={1.4}>
            {desc}
          </Text>
        </Box>
      </Stack>
    </Paper>
  );
}

function PropertyCard() {
  return (
    <Card padding="lg" radius="lg" withBorder style={{ borderColor: '#E9ECEF' }}>
      <Card.Section pos="relative">
        <Image src="https://placehold.co/400x250" height={220} alt="House" />
        <Badge
          pos="absolute"
          top={15}
          left={15}
          variant="white"
          color="navy.9"
          leftSection={<IconBriefcase size={12} />}
          size="md"
          styles={{ root: { textTransform: 'none', fontWeight: 600 } }}
        >
          Düşük Bütçeli
        </Badge>
      </Card.Section>

      <Stack mt="md" gap="xs">
        <Group justify="space-between">
          <Group gap={6}>
            <Box w={8} h={8} bg="blue" style={{ borderRadius: '50%' }} />
            <Text c="blue" fw={700} fz="sm">
              Mevcut
            </Text>
          </Group>
        </Group>

        <Group justify="space-between" align="flex-end">
          <Box>
            <Text fw={700} fz={rem(20)} c="navy.9">
              Mevsim İstanbul
            </Text>
            <Group gap={4} c="dimmed">
              <IconMapPin size={16} />
              <Text fz="sm">Kadıköy/İstanbul</Text>
            </Group>
          </Box>
          <Box ta="right">
            <Text fw={700} fz={rem(20)} c="navy.7">
              ₺900.000
            </Text>
            <Text fz="xs" c="dimmed">
              Hisse Tutarı
            </Text>
          </Box>
        </Group>

        <Divider my="sm" />

        <Group justify="space-between">
          <Text fz="sm" fw={500}>
            Aylık Kira/Pay
          </Text>
          <Text fz="sm" fw={700}>
            ₺50.000
          </Text>
        </Group>
        <Group justify="space-between">
          <Text fz="sm" fw={500}>
            Mülk Değeri
          </Text>
          <Text fz="sm" fw={700}>
            ₺9.000.000
          </Text>
        </Group>

        <Box mt="xs">
          <Group justify="space-between" mb={5}>
            <Text fz="xs" fw={600}>
              4 pay satıldı
            </Text>
          </Group>
          <Group grow gap={4}>
            <Box h={6} bg="navy.8" style={{ borderRadius: 4 }} />
            <Box h={6} bg="navy.8" style={{ borderRadius: 4 }} />
            <Box h={6} bg="gray.2" style={{ borderRadius: 4 }} />
            <Box h={6} bg="gray.2" style={{ borderRadius: 4 }} />
            <Box h={6} bg="gray.2" style={{ borderRadius: 4 }} />
          </Group>
          <Group justify="space-between" mt={4}>
            <Text fz="xs" c="navy.8" fw={700}>
              %40
            </Text>
            <Text fz="xs" c="dimmed">
              %100
            </Text>
          </Group>
        </Box>

        <Group mt="md" grow>
          <Button variant="outline" color="gray.6" radius="md">
            Detaylı İncele
          </Button>
          <Button variant="filled" color="navy.9" radius="md" rightSection={<IconArrowRight size={16} />}>
            Hisse Al
          </Button>
        </Group>
      </Stack>
    </Card>
  );
}

SiteHome.layout = page => createSiteLayout(page, { bg: 'white' });
